import { render, staticRenderFns } from "./DepositoDentalFormDialog.vue?vue&type=template&id=0db6d088"
import script from "./DepositoDentalFormDialog.vue?vue&type=script&lang=js"
export * from "./DepositoDentalFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports